"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivacyPolicyBox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledLayout = require("../../../StyledLayout");

var PrivacyPolicyBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__PrivacyPolicyBox",
  componentId: "sc-1bv5wek-0"
})(["position:relative;width:100%;max-width:656px;margin:0 auto;"]);
exports.PrivacyPolicyBox = PrivacyPolicyBox;